// ENG-35016: auto-follow must move the active sentence up before it reaches the
// scrollport's bottom edge, not right at it.
export const AUTO_FOLLOW_BOTTOM_INSET = 64
// Where a follow scroll places the active sentence, measured from the top of
// the scrollport.
export const AUTO_FOLLOW_TOP_OFFSET = 100

// Whether the active sentence is far enough from the bottom edge (and clear of
// the top edge) that auto-follow does not need to scroll. Takes plain rects, not
// DOM elements, so this stays unit-testable without a real layout engine. The
// inset is clamped to a quarter of the container's height so a short/collapsed
// mobile bottom-sheet scrollport can't have it eat an unreasonable share of the
// visible area. A sentence that a follow scroll could not move up any further
// also counts as in view - one already at or above the landing spot (in a
// scrollport under ~190px that spot sits inside the inset), or any sentence
// once the scrollport is scrolled to the end (the last few sentences of a
// transcript). Otherwise every timeupdate would start another zero-distance
// scroll.
export function isSentenceInFollowView(
  sentenceRect,
  containerRect,
  {
    atScrollEnd = false,
    maxInset = AUTO_FOLLOW_BOTTOM_INSET,
    topOffset = AUTO_FOLLOW_TOP_OFFSET,
  } = {}
) {
  const containerHeight = containerRect.bottom - containerRect.top
  const inset = Math.max(0, Math.min(maxInset, containerHeight * 0.25))

  return (
    sentenceRect.top >= containerRect.top &&
    (sentenceRect.bottom <= containerRect.bottom - inset ||
      sentenceRect.top - containerRect.top <= topOffset ||
      atScrollEnd)
  )
}

// The "Return to current position" control (ENG-31401) is a manual-scroll-away
// affordance only. It must stay hidden whenever auto-follow is on, or while any
// programmatic scroll is in flight - otherwise it can flash on during ordinary
// auto-follow adjustments. The controller reports auto-follow as off while
// search is active (it never follows then), so the control still shows for an
// off-screen playhead during search.
export function returnControlState({
  shouldAutoScroll,
  isScrolling,
  sentenceRect,
  containerRect,
}) {
  if (isScrolling || shouldAutoScroll || !sentenceRect) {
    return { hidden: true, isAbove: false }
  }

  const isAbove = sentenceRect.top < containerRect.top
  const isBelow = sentenceRect.bottom > containerRect.bottom

  return { hidden: !isAbove && !isBelow, isAbove }
}
